import { createFileRoute } from "@tanstack/react-router";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { AthleteQuestionnaireLayout } from "src/pages/AthleteQuestionnaireLayout";
import { createOrganizationQuestionnairesRepository } from "src/repositories/questionnaires/createOrganizationQuestionnairesRepository";
export const Route = createFileRoute(
  "/_auth/_coach/orgs/$slug/athletes/$athleteId/_tabs/questionnaires/$questionnaireId",
)({
  component: RouteComponent,
  ssr: true,
  async loader({ context, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => ({
        data: await context.queryClient.query({
          ...createOrganizationQuestionnairesRepository(
            organization.id,
          ).submissionsOptions(params.athleteId, params.questionnaireId, {
            pageIndex: 0,
            pageSize: 20,
          }),
          staleTime: "static",
        }),
      }),
    );
  },
});

function RouteComponent() {
  const { questionnaireId } = Route.useParams();
  return <AthleteQuestionnaireLayout questionnaireId={questionnaireId} />;
}
